import { IProgressBarStep } from '../../interfaces/IProgressBarStep';

export const stepsList: IProgressBarStep[][] = [
  [
    {
      content: 'Your details',
      status: 'current',
    },
    {
      content: 'Suspension ID',
      status: 'todo',
    },
    {
      content: 'Declaration',
      status: 'todo',
    },
    {
      content: 'Review & Submit',
      status: 'todo',
    },
  ],
  [
    {
      content: 'Your details',
      status: 'completed',
    },
    {
      content: 'Suspension ID',
      status: 'current',
    },
    {
      content: 'Declaration',
      status: 'todo',
    },
    {
      content: 'Review & Submit',
      status: 'todo',
    },
  ],
  [
    {
      content: 'Your details',
      status: 'completed',
    },
    {
      content: 'Suspension ID',
      status: 'completed',
    },
    {
      content: 'Declaration',
      status: 'current',
    },
    {
      content: 'Review & Submit',
      status: 'todo',
    },
  ],
  [
    {
      content: 'Your details',
      status: 'completed',
    },
    {
      content: 'Suspension ID',
      status: 'completed',
    },
    {
      content: 'Declaration',
      status: 'completed',
    },
    {
      content: 'Review & Submit',
      status: 'current',
    },
  ],
];
